import { Injectable, inject } from '@angular/core';
import { Firestore, collection, addDoc } from '@angular/fire/firestore';
import { Result } from '_models/result';
import { DatePipe, CurrencyPipe } from '@angular/common';

/** Must match guestSessions TTL in session.service (share / email links). */
const GUEST_LINK_RETENTION_DAYS = 30;
const DAY_MS = 24 * 60 * 60 * 1000;

export interface EmailResultsPayload {
  universityName: string;
  /** Raw Quill HTML; empty when the school has no next steps. */
  nextStepsHtml: string;
}

interface EmailResult {
  emailAddress: string;
  fromAddress: string;
  universityName: string;
  netPrice: string;
  academicYear: string;
  resultsTimeStamp: string;
  sessionUrl: string;
  nextStepsHtml: string;
  /** When the share link / email was created. */
  createdAt: Date;
  /** When the guest session link expires (guestSessions TTL). */
  expiresAt: Date;
}

@Injectable()
export class EmailService {
  private afs = inject(Firestore);

  fromAddress = 'npc_system@rewiretech.com';

  public emailResults(
    emailAddress: string,
    url: string,
    aidYear: string,
    result: Result,
    payload: EmailResultsPayload,
  ) {
    const datePipe = new DatePipe('en-US');
    const currencyPipe = new CurrencyPipe('en-US');
    const createdAt = new Date();
    const expiresAt = new Date(createdAt.getTime() + GUEST_LINK_RETENTION_DAYS * DAY_MS);

    const npcDoc: EmailResult = {
      emailAddress,
      fromAddress: this.fromAddress,
      universityName: payload.universityName.trim(),
      netPrice: currencyPipe.transform(result.netPrice, 'USD', 'symbol', '1.0-0') || '',
      academicYear: aidYear,
      resultsTimeStamp: 'Results as of ' + datePipe.transform(result.createdAt, 'short'),
      sessionUrl: url,
      nextStepsHtml: payload.nextStepsHtml.trim(),
      createdAt,
      expiresAt,
    };

    const emailResultsCollection = collection(this.afs, 'emailResults');
    addDoc(emailResultsCollection, npcDoc)
      .then(docRef => console.log('Record added to email results: ', docRef.id))
      .catch(error => console.error('Error adding document: ', error));
  }
}
